const CONSTANTS = {
	//LOGIN ACTION CONSTANTS
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',

	//LOGOUT ACTION CONSTANTS
	LOGOUT_REQUEST: 'LOGOUT_REQUEST',
	LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
	LOGOUT_FAILURE: 'LOGOUT_FAILURE',

	//PAYMENT ACTION CONSTANTS
	PAYMENT_INITIAL_REQUEST: 'PAYMENT_INITIAL_REQUEST',
	PAYMENT_INITIAL_SUCCESS: 'PAYMENT_INITIAL_SUCCESS',
	PAYMENT_INITIAL_FAILURE: 'PAYMENT_INITIAL_FAILURE',

	//STORE USER DETAILS ACTION CONSTANTS
	STORE_USER_DETAILS_REQUEST: 'STORE_USER_DETAILS_REQUEST',
	STORE_USER_DETAILS_SUCCESS: 'STORE_USER_DETAILS_SUCCESS',
	STORE_USER_DETAILS_FAILURE: 'STORE_USER_DETAILS_FAILURE',

	//EVENT ACTION CONSTANTS
	EVENT_INITIAL_REQUEST: 'EVENT_INITIAL_REQUEST',
	EVENT_INITIAL_SUCCESS: 'EVENT_INITIAL_SUCCESS',
	EVENT_INITIAL_FAILURE: 'EVENT_INITIAL_FAILURE',
	UPDATE_EVENT_STATE: 'UPDATE_EVENT_STATE',

	//PROMOCODE ACTION CONSTANTS
	GET_PROMOCODE_REQUEST: 'GET_PROMOCODE_REQUEST',
	GET_PROMOCODE_SUCCESS: 'GET_PROMOCODE_SUCCESS',
	GET_PROMOCODE_FAILURE: 'GET_PROMOCODE_FAILURE',

	//PROMOCODE USAGE ACTION CONSTANTS
	GET_PROMOCODE_USAGE_REQUEST: 'GET_PROMOCODE_USAGE_REQUEST',
	GET_PROMOCODE_USAGE_SUCCESS: 'GET_PROMOCODE_USAGE_SUCCESS',
	GET_PROMOCODE_USAGE_FAILURE: 'GET_PROMOCODE_USAGE_FAILURE',

	//AFTER PAYMENT ACTION CONSTANTS
	AFTER_PAYMENT_REQUEST: 'AFTER_PAYMENT_REQUEST',
	AFTER_PAYMENT_SUCCESS: 'AFTER_PAYMENT_SUCCESS',
	AFTER_PAYMENT_FAILURE: 'AFTER_PAYMENT_FAILURE',

	//AFTER PAYMENT ACTION DOWNLOAD QR CONSTANTS
	QRCODE_REQUEST: 'QRCODE_REQUEST',
	QRCODE_REQUEST_SUCCESS: 'QRCODE_REQUEST_SUCCESS',
	QRCODE_REQUEST_FAILURE: 'QRCODE_REQUEST_FAILURE',

	//PASS ACTION CONSTANTS
	PASS_INITIAL_REQUEST: 'PASS_INITIAL_REQUEST',
	PASS_INITIAL_SUCCESS: 'PASS_INITIAL_SUCCESS',
	PASS_INITIAL_FAILURE: 'PASS_INITIAL_FAILURE',

	//PASS ACTION CONSTANTS
	EVENT_LOG_REQUEST: 'EVENT_LOG_REQUEST',
	EVENT_LOG_SUCCESS: 'EVENT_LOG_SUCCESS',
	EVENT_LOG_FAILURE: 'EVENT_LOG_FAILURE',

	//PASS ACTION CONSTANTS
	GET_IP_REQUEST: 'GET_IP_REQUEST',
	GET_IP_SUCCESS: 'GET_IP_SUCCESS',
	GET_IP_FAILURE: 'GET_IP_FAILURE',

	//Get OTP ACTION CONSTANTS
	GET_OTP_REQUEST: 'GET_OTP_REQUEST',
	GET_OTP_SUCCESS: 'GET_OTP_SUCCESS',
	GET_OTP_FAILURE: 'GET_OTP_FAILURE',

	//Confirm Otp ACTION CONSTANTS
	GET_CONFIRM_OTP_REQUEST: 'GET_CONFIRM_OTP_REQUEST',
	GET_CONFIRM_OTP_SUCCESS: 'GET_CONFIRM_OTP_SUCCESS',
	GET_CONFIRM_OTP_FAILURE: 'GET_CONFIRM_OTP_FAILURE',

	//booking before payment ACTION CONSTANTS
	BEFORE_PAYMENT_INITIAL_REQUEST: 'BEFORE_PAYMENT_INITIAL_REQUEST',
	BEFORE_PAYMENT_INITIAL_SUCCESS: 'BEFORE_PAYMENT_INITIAL_SUCCESS',
	BEFORE_PAYMENT_INITIAL_FAILURE: 'BEFORE_PAYMENT_INITIAL_FAILURE',

	//booking after payment ACTION CONSTANTS
	AFTER_PAYMENT_INITIAL_REQUEST: 'AFTER_PAYMENT_INITIAL_REQUEST',
	AFTER_PAYMENT_INITIAL_SUCCESS: 'AFTER_PAYMENT_INITIAL_SUCCESS',
	AFTER_PAYMENT_INITIAL_FAILURE: 'AFTER_PAYMENT_INITIAL_FAILURE',

	ADD_EVENT_LOG_REQUEST: 'ADD_EVENT_LOG_REQUEST',
	ADD_EVENT_LOG_SUCCESS: 'ADD_EVENT_LOG_SUCCESS',
	ADD_EVENT_LOG_FAILURE: 'ADD_EVENT_LOG_FAILURE',

	FORM_SUBMIT_DATA: 'FORM_SUBMIT_DATA',

}
export default CONSTANTS
